/**
 * 404: the Router's default route (audit 2026-06-11).
 *
 * Two jobs:
 *  1. Catch unknown paths with the /about voice instead of a blank cream page
 *     (the Router previously had no default route at all).
 *  2. Rescue the most likely typed URL, a bare 4-char room code
 *     ("drawlol.com/AB2C", the code people read aloud), by forwarding it to
 *     the real room path /r/AB2C.
 */
import { useEffect } from "preact/hooks";
import { useLocation } from "preact-iso";
import { InkCat } from "../marks/v1/InkCat.js";

/** A bare room code typed straight after the domain. */
const BARE_CODE = /^\/([a-zA-Z0-9]{4})\/?$/;

export function NotFound() {
  const { path, route } = useLocation();
  const code = BARE_CODE.exec(path)?.[1];

  useEffect(() => {
    if (code) route(`/r/${code.toUpperCase()}`, true);
  }, [code, route]);

  // Forwarding to the room: don't flash the 404 copy.
  if (code) return null;

  return (
    <main class="not-found" data-testid="not-found" role="main">
      {/* The mascot naps on the dead end (PRD §5.5, sleepy pose, idle surface). */}
      <div class="not-found-cat">
        <InkCat pose="sleepy" size={72} />
      </div>
      <h1 class="not-found-heading">There's nothing here.</h1>
      <p class="not-found-hint">
        Maybe the link got mangled. Room links look like{" "}
        <code class="not-found-code">drawlol.com/r/CODE</code>.
      </p>
      <p class="not-found-home-row">
        <a class="not-found-home" href="/" data-testid="not-found-home">
          ← back to drawlol
        </a>
      </p>
    </main>
  );
}
